<template lang="pug">
.qa_item(:class="{ expand: isExpand }")
  .question.flex_h.justify-content-between.align-items-center.i_mlr_md_4.i_mlr_sm_2(
    @click="expand"
  )
    h5.i_mt_1.i_mt_sm_0 Q：{{ QuestionContent.FAQTitle }}
    svg-icon.i_ml_2(iconClass="arrow_bottom_g", className="arrow_bottom_g")
  .answer_wrapper.flex_h.flex_sm_v.i_mt_4.i_mlr_md_4.i_mlr_sm_3(ref="answer")
    span A：
    .answer.i_ml_3.i_ml_sm_0.i_mr_14.i_mr_md_0.i_mr_sm_3
      p(v-html="QuestionContent.FAQContent")
  hr.i_mt_6
</template>

<script>
import Velocity from "velocity-animate";

export default {
  name: "QAHtmlItem",
  props: {
    QuestionContent: Object,
  },
  data() {
    return {
      isExpand: false,
      content: "",
      screenWidth: document.documentElement.clientWidth, //螢幕寬度
    };
  },
  watch: {
    "$store.state.screenWidth": function () {
      if (this.isExpand) {
        //取得元素完整高度
        var height = this.$refs.answer.scrollHeight + 20;

        Velocity(
          this.$refs.answer,
          { maxHeight: height, opacity: 1 },
          { duration: 0 }
        );
      }
    },
  },
  mounted() {
    this.onResize();
  },
  methods: {
    onResize() {
      var thiz = this;

      window.onresize = function () {
        // 定義視窗大小變更通知事件
        thiz.$store.state.screenWidth = document.documentElement.clientWidth; //視窗寬度
      };
    },
    expand() {
      this.isExpand = !this.isExpand;

      if (this.isExpand) {
        //取得元素完整高度
        var height = this.$refs.answer.scrollHeight + 20;

        Velocity(
          this.$refs.answer,
          { maxHeight: height, opacity: 1 },
          { duration: 200 }
        );
      } else {
        Velocity(
          this.$refs.answer,
          { maxHeight: 0, opacity: 0 },
          { duration: 200 }
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/qa_item";

.qa_item {
  .answer {
    border: none;
  }
}
</style>
